module.exports = __webpack_public_path__ + "img/pt-20.48b7fbe8.svg";